import {
  faChartPie,
  faDroplet,
  faExternalLink,
  faFaucetDrip,
  faRightLeft,
  faScaleUnbalanced,
  faSquareUpRight,
} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import NavigationButton from "../buttons/NavigationButton";
import NavigationLink from "../buttons/NavigationLink";

const NavLinks = () => {
  return (
    <div className="navlinks-container">
      <NavigationButton icon={faRightLeft} name={"Swap"} pathName="/" />
      <NavigationButton icon={faDroplet} name={"Pools"} pathName="/pools" />
      <NavigationButton icon={faChartPie} name={"Assets"} pathName="/asset" />
      <NavigationLink
        icon={faScaleUnbalanced}
        name={"Gauges"}
        // pathName="https://secretswap-gov-interface.vercel.app"
        pathName=""
        icon2={faExternalLink}
        disabled = {true}
      />
      <NavigationLink
        icon={faFaucetDrip}
        name={"Faucet"}
        pathName="https://faucet.pulsar.scrttestnet.com/"
        icon2={faExternalLink}
        disabled = {false}
      />
    </div>
  );
};

export default NavLinks;
